import React, { PureComponent } from 'react'
import {
  VictoryAxis,
  VictoryChart,
  VictoryBar,
  VictoryGroup,
  VictoryLegend
} from 'victory'
import theme from './theme'
import ChartTooltip from './ChartTooltip'

class GroupedBarChart extends PureComponent {
  createGroups () {
    const { data, y, chartStyles, groupByFilters } = this.props
    const groupedData = groupByFilters.map(filter => data.filter(filter))

    const groups = groupedData.map(data => (
      <VictoryBar
        data={data}
        x={d => new Date(parseInt(d.x, 10), 1)}
        y={y}
        style={chartStyles ? chartStyles.bar : null}
        labels={d => `${d.x}: ${d.y}`}
        labelComponent={<ChartTooltip />}
      />
    ))

    return groups
  }

  render () {
    const { categories, legendCategories } = this.props
    const groups = this.createGroups()

    return (
      <VictoryChart
        height={200}
        theme={theme}
        padding={{ top: 25, bottom: 40, left: 40, right: 20 }}
        style={{
          parent: {}
        }}
        responsive={false}
      >
        <VictoryAxis dependentAxis />
        <VictoryAxis scale={{ x: 'time' }} />
        <VictoryLegend orientation='horizontal' data={legendCategories} />
        <VictoryGroup offset={30} catgories={categories}>
          {groups}
        </VictoryGroup>
      </VictoryChart>
    )
  }
}

export default GroupedBarChart



// WEBPACK FOOTER //
// ./src/charts/GroupedBarChart.js